export default __webpack_public_path__ + "static/media/dollar.78da48ac.png";